import axios from '@/plugins/axios'
import type IDataResponse from '@/interfaces/api-resources/DataResponse'
import { useAppStore } from '@/stores/app'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return appStore.daraApiBaseUrl
  },

  async get(organisationId: number, libraryFolderId: number) {
    return axios.get<
      IDataResponse<Domain.ResourceLibrary.Resources.ApiV3.LibraryFileResource[]>,
      IDataResponse<Domain.ResourceLibrary.Resources.ApiV3.LibraryFileResource[]>
    >(`${ this.baseUrl() }/organisations/${ organisationId }/library-folders/${ libraryFolderId }/library-files/`)
  },

  async search(organisationId: number, search: string) {
    return axios.get<
      IDataResponse<Domain.ResourceLibrary.Resources.ApiV3.LibraryFileResource[]>,
      IDataResponse<Domain.ResourceLibrary.Resources.ApiV3.LibraryFileResource[]>
    >(`${ this.baseUrl() }/organisations/${ organisationId }/library-files/search/?search=${ search }`)
  },

  async download(libraryFileId: number) {
    return axios.get<string, string>(`${ this.baseUrl() }/library-files/${ libraryFileId }/download/`)
  },
}
